/* eslint-disable max-len */

// This should be as is from prod. To override, use index.html
// Run the following to retrieve the latest dcr in prod:
//      copy(JSON.stringify(Object.assign({}, DCR || {}, JSON.parse(document.querySelector(".dcr-data").value)), null, 4))
export const DCR = {
	'ALL_ETF_HEADER': 'All ETF',
	'ALL_ETF_SUB_HEADER': 'Keep portfolio costs low with ETFs',
	'MUTUAL_FUND_AND_ETF_HEADER': 'Mutual fund & ETF',
	'MUTUAL_FUND_AND_ETF_SUB_HEADER': 'Includes actively managed mutual funds and/or liquid alternatives',
	'TAX_AWARE_HEADER': 'Tax-Aware',
	'TAX_AWARE_SUB_HEADER': 'For tax-sensitive investors',
	'SUSTAINABLE_HEADER': 'Sustainable',
	'SUSTAINABLE_SUB_HEADER': 'Exposure to companies with positive ESG attributes',
	'HIGH_NET_GROWTH_HEADER': 'High net worth',
	'HIGH_NET_GROWTH_SUB_HEADER': 'Combines SMAs & ETFs, and/or liquid alternatives',
	'HIGHLIGHTEDFILTER_GROWTH': 'Growth',
	'HIGHLIGHTEDFILTER_INCOME': 'Income',
	'HIGHLIGHTEDFILTER_CAPITAL_PRESERVATION': 'Capital Preservation',
	'HIGHLIGHTEDFILTER_ESG': 'ESG',
	'HIGHLIGHTEDFILTER_TAX_AWARE': 'Tax Aware',
	'HIGHLIGHTEDFILTER_ALTERNATIVES': 'Alternatives',
	'FILTERNAME_RISKPROFILE': 'Risk Profile',
	'FILTERNAME_PREFERENCES': 'Preferences',
	'FILTERNAME_TRADEFREQUENCY': 'Trade Frequency',
	'FILTERNAME_VEHICLE': 'Underlying Investment Vehicle(s)',
	'FILTERNAME_OPENARCHITECTURE': '3rd Party Funds',
	'FILTERNAME_MODELCATEGORYTYPE': 'BlackRock Management Team',
	'FILTEROPT_CONSERVATIVE': 'Conservative',
	'FILTEROPT_MODERATE_CONSERVATIVE': 'Moderate Conservative',
	'FILTEROPT_MODERATE': 'Moderate',
	'FILTEROPT_MODERATE_AGGRESSIVE': 'Moderate Aggressive',
	'FILTEROPT_AGGRESSIVE': 'Aggressive',
	'FILTEROPT_ESG': 'ESG',
	'FILTEROPT_TAX_AWARE': 'Tax Aware',
	'FILTEROPT_FACTORS': 'Factors',
	'FILTEROPT_ALTERNATIVES': 'Alts',
	'FILTEROPT_NO_PREFERENCE': 'None',
	'FILTEROPT_MONTHLY': 'Monthly',
	'FILTEROPT_QUARTERLY': 'Quarterly',
	'FILTEROPT_SEMI_ANNUALLY': 'Semi-Annually',
	'FILTEROPT_ANNUAL': 'Annual',
	'FILTEROPT_ETF_ONLY': 'ETF Only',
	'FILTEROPT_ETF_AND_MF': 'ETF and MF',
	'FILTEROPT_MF_ONLY': 'MF Only',
	'FILTEROPT_OPEN': 'Open',
	'FILTEROPT_CLOSED': 'Closed',
	'FILTEROPT_MAS_MPS_MANAGED_MODELS': 'Target Allocation',
	'FILTEROPT_MAS_INCOME': 'Multi Asset Income',
	'FILTEROPT_PMG_FI_GLOBAL_ALLOCATION': 'Global Allocation',
	'MINI_COMPARE_DATA_TABLE_DISCLOSURE': 'MINI_COMPARE_DATA_TABLE_DISCLOSURE',
	'MODEL_COUNT_TEXT': 'results',
	'EMPTY_MODEL_LIST_TEXT_1': 'There are no models available',
	'EMPTY_MODEL_LIST_TEXT_2': 'based on your filter selections. Please select another filters',
	'CUSTOM_ADVISORY_FEE_TOOLTIP_CTA': ' ',
	'CURRENT_CUSTOM_ADVISORY_FEE_SHORT_TITLE': 'Advisory Fee:',
	'EDIT_CUSTOM_ADVISORY_FEE_SHORT_TITLE': 'Edit Advisory Fee',
	'GROWTH_EXPLORE_CARD_TITLE': 'Growth',
	'INCOME_EXPLORE_CARD_TITLE': 'Income',
	'CAPITAL_PRESERVATION_EXPLORE_CARD_TITLE': 'Capital Preservation',
	'GROWTH_EXPLORE_CARD_CONTENT': 'Grow assets over the long-term',
	'INCOME_EXPLORE_CARD_CONTENT': 'Generate Higher Income',
	'CAPITAL_PRESERVATION_EXPLORE_CARD_CONTENT': 'Seeks to limit downside',
	'FILTERS_HEADING': 'FILTERS',
	'MINI_COMPARE_SHOW_MORE_DATA_LABEL': 'Show more data',
	'MINI_COMPARE_SHOW_LESS_DATA_LABEL': 'Show less data',
	'FIND_COMPARE_NO_MODEL_FAMILIES': 'Some error occurred. Please reload or try again later',
	'MINI_COMPARE_TABLE_DATA_LAYER_ERROR': 'Error occurred. Please contact support.',
	'MODEL_LIST_MISSING_RISK_PROFILE': 'Risk Profile is not available',
	'MODEL_LIST_NO_DATA': 'Data mismatch or missing data',
	'MODELS_ERROR_OCCURRED': 'Some error occurred',
	'MINI_COMPARE_DIALOG_DISCLOSURE': `Investment comparisons are for illustrative purposes only. To better understand the similarities
	and differences between investments, including investment objectives, risks, fees and expenses, it is important to read the products' prospectuses.`,
	'DCR_MB_COVER_PAGE_TITLE': '<tspan x="36" y="104">Model Portfolio </tspan>\n<tspan x="36" y="174">Summary</tspan>',
	'DCR_MB_CUSTOM_COVER_PAGE_TITLE': 'Model Portfolio Summary',
	'DCR_MB_REPORT_GENERATED_ON_TITLE': 'Report generated on:',
	'ADD_CUSTOM_ADVISORY_FEE_TITLE': 'Add Advisory Fee',
	'ME_PERFORMANCE_DETAILS_TABLET_DISCLOSURE': 'Please navigate to a larger screen size (such as desktop) or zoom out to see performance',
	'ESG_METRIC_FORESTS_CUT_PER_YEAR_UNIT': 'acres/yr',
	'ESG_METRIC_PASSENGER_VEHICLES_DRIVEN_UNIT': 'vehicles/yr',
	'ESG_METRIC_HOMES_ENERGY_PER_YEAR_UNIT': 'homes/yr',
	'ESG_METRIC_POUNDS_COAL_BURNED_UNIT': 'lbs',
	'ESG_METRIC_CARBON_EMISSION_DIFFERENCE_UNIT': '%',
	'ESG_METRIC_PETROL_CONSUMED_UNIT': 'litres',
	'ESG_METRIC_FORESTS_CUT_PER_YEAR_LABEL': 'Acres of U.S. Forests in one year',
	'ESG_METRIC_PASSENGER_VEHICLES_DRIVEN_LABEL': 'Passenger Vehicles Driven for one year',
	'ESG_METRIC_HOMES_ENERGY_PER_YEAR_LABEL': 'Homes Energy Use for one year',
	'ESG_METRIC_POUNDS_COAL_BURNED_LABEL': 'Pounds of Coal Burned',
	'ESG_METRIC_POUNDS_COAL_BURNED_TOOLTIP': 'Pounds of Coal Burned',
	'ESG_METRIC_CARBON_EMISSION_DIFFERENCE_LABEL': 'Carbon Emission Difference',
	'ESG_METRIC_PETROL_CONSUMED_LABEL': 'Petrol Consumed',
	'ESG_CARBON_SCORE_IMPACT_TITLE': 'CARBON EMISSIONS REDUCTION EQUIVALENTS',
	'ESG_CARBON_SCORE_IMPACT_SUBTITLE': ' ',
	'PDF_LATEST_HOLDING_H2': 'Latest Holdings (%)',
	'PDF_CHANGES_TO_HOLDING_H2': 'Changes To Holdings (%)',
	'LOADING_TEXT': 'Loading...'
};
